import { GlobalService, LocalStorageService } from 'src/app/services/index.service';
import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { BehaviorSubject, catchError, concatMap, distinctUntilChanged, filter, first, forkJoin, map, merge, mergeMap, Observable, of, shareReplay, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IAnalyze } from 'src/app/shared/interfaces/analyze.interface';
import { MultipleCriteria } from 'src/app/shared/interfaces/multiple-criteria.interface';
import { AnalyzeService } from './analyze.service';

@Injectable({
  providedIn: 'root'
})
export class ManagementService {
  requestAudit = signal(false)
  analyserDataSignal = signal([]);
  private internalAnalyserUsernameList = signal([])
  readonly BASE_URL = environment.BASE_API_URL;
  readonly QUIZ_BASE_URL = environment.QUIZ_API_URL;
  PROGRAM_PAYMENT_OBJECT = {creation_price:70000, default_person_count:10,price_per_person:100000};
  username:string = ''
  organListUsername:string[] = []
  reportCardSettingBar:BehaviorSubject<boolean> = new BehaviorSubject(false)
  analysisCount = 1;
  programProgressObj:any = {
    "firstStep":{action:'ADD',loading:false},
    "secondStep":{action:'ADD',loading:false},
    "profileStep":{action:'ADD',loading:false},
    "thirdStep":{action:'ADD',loading:false},
    "fourthStep":{action:'ADD',loading:false},
    "sixthStep":{action:'ADD',loading:false},
  }
  firstForm:any
  charactersForm:any = [];
  profileRequiredDatasForm:any = []
  requiredDatasForm:any = []
  requiredQuizForm:any = []
  internalAnalyser:any = []
  finalDataForm:any
  dataStepForm:any
  
  constructor(
    private http:HttpClient,
    private globalService:GlobalService,
    private storageService:LocalStorageService,
    private analyzeService:AnalyzeService,
  ) { }
  getReviewData(secret_analysis:any){
    return this.globalService.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.get<IAnalyze[]>(`${this.QUIZ_BASE_URL}analysis/${secret_analysis}`).pipe(catchError(err=>{throw err}))
      })
    )
  }

  getReviewDataForm(id:any){
    return this.globalService.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.get<IAnalyze[]>(`${this.QUIZ_BASE_URL}analysis/form/${id}`).pipe(catchError(err=>{throw err}))
      })
    )
  }
  initializeNewProgram(data:any){
    return this.globalService.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.post<IAnalyze[]>(`${this.QUIZ_BASE_URL}analysis/form/`,data).pipe(catchError(err=>{throw err}))
      })
    )
  }
  getAnalyzeListData(secretKey:string){
    return this.globalService.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.get<any>(`${this.QUIZ_BASE_URL}analysis/${secretKey}/`).pipe(catchError(err=>{throw err}))
      })
    )
  }
  getEntitys(usernameList:string[]){
    return this.http.get<any>(`${this.BASE_URL}entity/?username__in=${usernameList?.join(',')}&page_size=${usernameList.length}`)
  }
  getSingleAnalyzeData(analyzeId:any){
    return this.globalService.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.get<any>(`${this.QUIZ_BASE_URL}analysis/form/${analyzeId}/`).pipe(catchError(err=>{throw err}))
      })
    )
  }
  getInternalAnalyser(form_id:any){
    return this.globalService.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap(()=>{
        return this.http.get<any>(`${this.QUIZ_BASE_URL}analysis/form/${form_id}/analyser_list/`)
        .pipe(
          mergeMap((analyserData)=>of(analyserData).pipe(
            map((m:any)=>{
              this.internalAnalyserUsernameList.set(m.map((i:any)=>i.analyser_username))
              return this.internalAnalyserUsernameList()
            }),
            mergeMap(m=>{
              return this.getEntitys(m ?? [])
            }),
            map(analyser=>{
              let personAccessibility
              let person = analyser.results.map((obj:any)=>{
              personAccessibility = analyserData.find((m:any)=>m.analyser_username==obj.username)
              let {characters,profile_required_datas,required_datas,accessible_required_datas,accessible_profile_required_datas,required_quizes} = personAccessibility ??[]
              return {
                characters,profile_required_datas,accessible_required_datas,accessible_profile_required_datas,required_datas,required_quizes,
                item:obj
              }
            })
          return person
          },
        ),
          )),
        )
        .pipe(catchError(err=>{throw err}))
      })
    )
  }
  isPrivate(notif:any){
    return notif.status=='PRIVATE'
  }
  isActive(notif:any){
      return notif.status=='ACTIVE'
  }
  isInActive(notif:any){
      return notif.status=='INACTIVE'
  }
  setInActiveClass(notif:any){
    if(notif?.status=='INACTIVE'){return true}
    else{
      if(notif?.is_started==false){return true}
      else{
        if(notif.is_expire) return true
        else return false
      }
    }
  }
  setActiveClass(notif:any){
    if((notif.is_started==true || notif.is_started==null) && notif.status=='ACTIVE' && !notif.is_expire){return true}
    else{return false}
  }
  isStart(notif:any){
      return notif.is_started
  }
  isExpired(notif:any){
      return notif.is_expire
  }
  editProgramFirstStep(data:any,progId:string){
    return this.globalService.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.patch<any>(`${this.QUIZ_BASE_URL}analysis/form/${progId}/`,data).pipe(catchError(err=>{throw err}))
      })
    )
  }
  editprogramDataSteps(data:any,progUsername:string){
    return this.globalService.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.patch<any>(`${this.QUIZ_BASE_URL}analysis/form/${progUsername}/`,data).pipe(catchError(err=>{throw err}))
      })
    )
  }
  editProfileRequiredData(data:any,secret_analysis:string){
    return this.globalService.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.patch<any>(`${this.QUIZ_BASE_URL}analysis/${secret_analysis}/`,data).pipe(catchError(err=>{throw err}))
      })
    )
  }
  editAnalyzerData(data:any,form_id:string,analyser_username:string){
    return this.globalService.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.post<any>(`${this.QUIZ_BASE_URL}analysis/form/${form_id}/internal_analyser/${analyser_username}/`,data).pipe(catchError(err=>{throw err}))
      })
    )
  }
  deleteRequiredDataType(analysis_id:string,id:any){
    return this.globalService.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.delete<any>(`${this.QUIZ_BASE_URL}analysis/${analysis_id}/required_data/${id}/`).pipe(catchError(err=>{throw err}))
      })
    )
  }
  deleteProfileRequiredDataType(analysis_id:string,id:any){
    return this.globalService.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.delete<any>(`${this.QUIZ_BASE_URL}analysis/${analysis_id}/profile_required_data/${id}/`).pipe(catchError(err=>{throw err}))
      })
    )
  }
  deleteInternalAnalyser(form_id:any,analyser_username:any){
    return this.globalService.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.delete<any>(`${this.QUIZ_BASE_URL}analysis/form/${form_id}/internal_analyser/delete/${analyser_username}/`).pipe(catchError(err=>{throw err}))
      })
    )
  }
    deleteCharectersDataType(analysis_id:string,id:any){
    return this.globalService.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.delete<any>(`${this.QUIZ_BASE_URL}character/${id}/analysis/${analysis_id}/delete/`).pipe(catchError(err=>{throw err}))
      })
    )
  }
  changeProgramProgressStatus(state:'firstStep'|'profileStep'|'secondStep'|'thirdStep'|'fourthStep'|'sixthStep'|'customQuestion',obj:any){
    this.programProgressObj[state] = obj
  }
  getProgramProgressObj(state:'firstStep'|'profileStep'|'secondStep'|'thirdStep'|'fourthStep'|'sixthStep'|'customQuestion'){
    return this.programProgressObj[state]
  }
  resetProgressObjc(){
    Object.keys(this.programProgressObj).forEach(
      (i:any)=>{
        this.programProgressObj[i] = {action:'ADD', loading:false}
      }
    )
  }
  setXStepForm(step:'firstForm'|'requiredQuizForm'|'profileRequiredDatasForm'|'charecterForm'|'requiredDataForm'|'finalForm'|'internalAnalyser',data:any){
    if(step=='firstForm') this.firstForm = data
    if(step=='profileRequiredDatasForm') this.profileRequiredDatasForm = data
    if(step=='charecterForm') this.charactersForm = data
    if(step=='requiredDataForm') this.requiredDatasForm = data
    if(step=='requiredQuizForm') this.requiredQuizForm = data
    if(step=='finalForm') this.finalDataForm = data
    if(step== 'internalAnalyser') this.internalAnalyser = data
  }
  getXstepForm(step:'firstForm'|'requiredQuizForm'|'profileRequiredDatasForm'|'charecterForm'|'requiredDataForm'|'finalForm'|'internalAnalyser'){
    if(step=='firstForm') return this.firstForm
    if(step=='profileRequiredDatasForm') return this.profileRequiredDatasForm
    if(step=='requiredDataForm') return this.requiredDatasForm
    if(step=='charecterForm') return this.charactersForm
    if(step=='requiredQuizForm') return this.requiredQuizForm
    if(step=='finalForm') return this.finalDataForm
    if(step== 'internalAnalyser') return this.internalAnalyser 
  }
  resetAllstepForm(){
    this.firstForm = null
    this.profileRequiredDatasForm = []
    this.requiredDatasForm = [] 
    this.charactersForm = []
    this.requiredQuizForm = []
    this.finalDataForm = null
    this.dataStepForm = null
    this.internalAnalyser = []
    this.internalAnalyserUsernameList.set([])
    this.charactersSub = new BehaviorSubject(null)
    this.quizListSubs = new BehaviorSubject(null)
  }
  getFormUsername(){
    return this.getXstepForm('firstForm').analysis
  }
  getAllQuizRequest(){
    return this.http.get<MultipleCriteria>(`${this.QUIZ_BASE_URL}multiple_criteria/`);
  }

  quizListSubs: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  quizListObs$ = this.quizListSubs.asObservable();
  setAllQuizList(quizList:any){
    this.quizListSubs.next(quizList)
  }
  getAllQuizListObs():Observable<any>{
    return this.quizListObs$
  }
  getAnalyzeList(page:number=1){
    return this.globalService.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.get<any>(`${this.QUIZ_BASE_URL}analysis/form/own_form/?page=${page}`).pipe(catchError(err=>{throw err}))
      })
    )
  }
  getTarhList(page:number=1){
    return this.globalService.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.get<any>(`${this.QUIZ_BASE_URL}analysis/?is_secret=False&page=${page}`).pipe(catchError(err=>{throw err}))
      })
    )
  }
  deleteAnalyzeForm(id:string){
    return this.globalService.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.delete<any>(`${this.QUIZ_BASE_URL}analysis/form/${id}`).pipe(catchError(err=>{throw err}))
      })
    )
  }
  lastStep(step: any, pointer: number): string {
    let lastStoredStep = Number(this.getXstepForm('firstForm')?.last_step) || 1;
    let targetStep = lastStoredStep;
    if (pointer <= 6) {
      if (pointer > lastStoredStep) {
          targetStep = step === 'next' ? pointer + 1 : lastStoredStep;
      } else if (lastStoredStep === pointer && step === 'next') {
          targetStep = lastStoredStep + 1;
      }
    } else {
      if (step === 'prev') {
          targetStep = lastStoredStep - 1;
      } else if (step === 'next') {
          targetStep = lastStoredStep + 1;
      }
    }
    // return "1";
    return targetStep.toString();
  }
  lastStepUpdate(step:any, id:any){
    return this.editprogramDataSteps(step,id)
  }
  programPayment(formId:any){
    return this.http.post<any>(`${this.QUIZ_BASE_URL}analysis/form/${formId}/pay/`,{}).pipe(catchError(err=>{throw err}))
  }
  programCharge(formId:any, amount:any){
    return this.http.post<any>(`${this.QUIZ_BASE_URL}analysis/form/${formId}/charge/`,amount).pipe(catchError(err=>{throw err}))
  }
  getProgramPrice(){
    return this.http.get<any>(`${this.QUIZ_BASE_URL}analysis/form/get_price/`).pipe(catchError(err=>{throw err}))
  }
  getTotalNumberRecords(formId:any){
    return this.http.get<any>(`${this.QUIZ_BASE_URL}analysis/form/submit/${formId}/total_records_count/`).pipe(catchError(err=>{throw err}))
  }
  getNotifDataWithAnalysers(form_id:any):Observable<any>{
    return this.getInternalAnalyser(form_id).pipe(shareReplay(0))
  }
  getInternalAnalyserUsernameList(){
    return this.internalAnalyserUsernameList()
  }
  setInternalAnalyserUsernameList(internalAnalyserUsernameList:any){
    this.internalAnalyserUsernameList.set(internalAnalyserUsernameList)
  }
  getQuizWithUsernameListObs(username_list: any) {
    return this.quizListObs$.pipe(
      filter((quiz: any) => username_list.includes(quiz.username))
    )
  }

  /// Characters
  private charactersSub:BehaviorSubject<any> = new BehaviorSubject<any>(null);
  charactersObs$ = this.charactersSub.asObservable();

  setCharacters(characters:any){
    this.charactersSub.next(characters)
  }
  getCharacters() : Observable<any>{
    return this.charactersObs$;
  }

  getCharactersListObs(search:any=null): Observable<any>{
    return this.http.get<any>(`${this.QUIZ_BASE_URL}analysis/character/?is_public=true`).pipe(catchError(err=>{throw err}))
  }

  editCharactersData(data:any,secret_analysis:string){
    return this.globalService.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.patch<any>(`${this.QUIZ_BASE_URL}analysis/${secret_analysis}/`,data).pipe(catchError(err=>{throw err}))
      })
    )
  }

  rejectFormSubmitRequests(formId:string, form_submites:string[]){
    return this.http.put<any>(`${this.QUIZ_BASE_URL}analysis/form/${formId}/remove_form_submit/`, {form_submites}).pipe(catchError(err=>{throw err}))
  }
  acceptFormSubmitRequests(formId:string, form_submites:string[]){
    return this.http.post<any>(`${this.QUIZ_BASE_URL}analysis/form/${formId}/verify_form_submit/`, {form_submites}).pipe(catchError(err=>{throw err}))
  }

  /* charge program and update data with storage cache */
  programChargeAllInOne(formId:string): Observable<any>{
    let pay = this.storageService.getData('pay');
    if(pay){
      return this.programCharge(formId,{amount:pay.count}).pipe(
        concatMap((res)=>{
          if(pay.type=='CWU'){
            return this.acceptFormSubmitRequests(formId,pay.users.split(',')).pipe(
              map(()=>res)
            )
          }
          return of(res)
        }),
        concatMap((res:any)=>{
          let obses$:any = {
            defualtPrice:this.getProgramPrice().pipe(first()),
            totalRecord:this.getTotalNumberRecords(formId).pipe(first()),
            verifiedUsers:this.analyzeService.getAnalysedUsersListByPlanId(formId,5,1,'-updated_at','','requester').pipe(first()),
            unverifiedUsers:this.analyzeService.getUnverifiedUsersListByPlanId(formId).pipe(first()),
          } 
          return forkJoin(obses$).pipe(
            catchError((error) => {
              console.log("Error occurred:", error);
              return of(null); // خطا را به صورت منطقی مدیریت کن
            })
          )
        })
      )
    }
    return of(null)
  }
}